var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('info-dialog-template', {
    attrs: {
      "title": _vm.$t('safe.deal.challenge.success.title')
    },
    on: {
      "click": _vm.handleClose
    },
    model: {
      value: _vm.isShownDialog,
      callback: function callback($$v) {
        _vm.isShownDialog = $$v;
      },
      expression: "isShownDialog"
    }
  }, [_c('div', {
    class: _vm.$style.container
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('safe.deal.challenge.success.description')))]), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.displayPayoutNotAvailable)
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }